import { createContext } from "../../utils/createContext";

import type { UseDrawerReturn } from "./useDrawer";

export const [DrawerProvider, useDrawerContext] = createContext<UseDrawerReturn>({
  name: "DrawerContext",
});
